module.exports = __webpack_public_path__ + "epdf-app/dashboard/batch/batch-tab-2cJAXLMj.html";